import React, { Component } from "react";
import { Modal } from "antd";

export default class ForgotPassword extends Component {
  // state list
  constructor(props) {
    super(props);
    this.state = {
      modalStatus: false,
      loading: false,
      email: "",
    };
  }
  openModal = () => {
    this.setState({ modalStatus: true });
  };
  closeModal = () => {
    this.setState({ modalStatus: false });
  };
  render() {
    return (
      <div>
        <a
          href="/forgot-password"
          className="forgot-pass-link"
          // onClick={() => this.openModal()}
        >
          Forgot Password?
        </a>
        <Modal
          visible={this.state.modalStatus}
          onCancel={() => this.closeModal()}
          footer={false}
        >
          <div className="reset-password-block">
            <h3 className="text-center">Reset Password</h3>
            <p>
              Enter your e-mail to receive instructions on how to reset your
              password.
            </p>
            <p>
              NOTE: You must first register and confirm your account via email
              before resetting your password.
            </p>

            <div className="form-group">
              <label>
                Your registered e-mail <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                name="email"
                value={this.state.email}
                onChange={(e) => this.setState({ email: e.target.value })}
              />
            </div>
            <button type="button">Reset My Password</button>
          </div>
        </Modal>
      </div>
    );
  }
}
